import { removeUserAdminRelation } from "../../../../core/api/useradmins/useradmins";
import useTranslations from "../../../../core/i18n/useTranslations";
import useUser from "../../../../core/user/useUser";
import { notify } from "../../../../ui-lib/components/Alerts/Toast";
import { notifyApiErrors } from "../../../../core/helpers/helpers";
import PrimeModal from "../../../../ui-lib/components/PrimeModal/PrimeModal";
import { useState } from "react";

const DeleteRelatedAdminModal = ({
  userAdminId,
  onClose,
  onDelete,
}: {
  userAdminId?: number;
  onClose: () => void;
  onDelete: () => void;
}) => {
  const t = useTranslations();

  const { authenticatedRequest } = useUser();

  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async () => {
    if (!userAdminId) {
      return;
    }

    try {
      setIsLoading(true);
      await removeUserAdminRelation(userAdminId, authenticatedRequest);

      notify({
        message: t("Messages:delete_related_admin_success"),
      });
      onDelete();
    } catch (error: any) {
      notifyApiErrors(error.response?.data?.errors);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <PrimeModal
      withFooter
      withHeader
      isOpen={!!userAdminId}
      loading={isLoading}
      header={t("Objects:delete_interaction")}
      onClose={onClose}
      fixedWidth="576px"
      submitBtn={{
        text: t("Common:delete"),
        variant: "destructive",
        onClick: onSubmit,
      }}
      cancelBtn={{
        text: t("Common:cancel"),
        onClick: onClose,
      }}
    >
      <p className="grey-600">{t("Objects:delete_related_admin_confirm")}</p>
    </PrimeModal>
  );
};

export default DeleteRelatedAdminModal;
